<template>
  <van-popup v-model="showpPopup" :overlay-style="{ background: 'rgba(0,0,0,.7)' }">
    <div class="receive-success">
      <img src="@/static/images/activityCenter/202405/01/14.png" />
      <div class="money">提现{{ money }}元</div>
      <div class="form-container">
        <div class="label-input">
          <span class="label">姓名</span>
          <input
            type="text"
            @input="changeInputVal('userNameKms')"
            :disabled="disabledName"
            v-model.trim="userName"
            :class="{ 'disabled': disabledName&&!this.$tools.isIOS() }"
            class="input"
          />
        </div>

        <div class="label-input">
          <span class="label">身份证号</span>
          <input
            type="text"
            @input="changeInputVal('idNoKms')"
            :disabled="disabledIdNo"
            v-model.trim="idNo"
            :class="{ 'disabled': disabledName&&!this.$tools.isIOS() }"
            class="input"
            maxlength="18"
          />
        </div>

        <div class="label-input">
          <span class="label">银行账号</span>
          <input type="text" @blur="changeBankVal" v-model.trim="cardNo" class="input" />
        </div>

        <div class="label-input" @click="$emit('show-bank')">
          <span class="label">开户行</span>
          <div class="input">{{ bankText }}</div>
        </div>

        <div class="label-input">
          <span class="label">手机号</span>
          <input @input="changeInputVal('mobileKms')" disabled v-model.trim="mobile" :class="{ 'disabled': disabledName&&!this.$tools.isIOS() }" class="input" />
        </div>

        <div class="label-input">
          <span class="label">验证码</span>
          <div class="code-box">
            <input type="number" :maxlength="6" v-model.trim="smsCode" class="code-input" />
            <span class="get-code" @click="checkCode" v-if="codeIndex == CODE_SIZE">获取验证码</span>
            <span class="get-code" v-else>{{ codeIndex }}s</span>
          </div>
        </div>
      </div>
      <div class="submit-btn" @click="submit"></div>
      <div class="close" @click="showpPopup = false"></div>
    </div>
  </van-popup>
</template>

<script>
import { common, codeTools } from '@/api/mixins';
export default {
  mixins: [common, codeTools],
  props: ['bankText', 'bank'],
  data() {
    return {
      showpPopup: false,
      showBankSelect: false,
      isChangeName: false,
      userName: '',
      userNameKms: '',
      isChangeIdNo: false,
      idNo: '',
      idNoKms: '',
      isChangeCardNo: false,
      cardNo: '',
      cardNoKms: '',
      mobile: '',
      mobileKms: '',
      smsCode: '',
      disabledName: false,
      disabledIdNo: false,
      money: null,
      userType: JSON.parse(localStorage.getItem('jzy_user')).userType
    };
  },

  methods: {
    open() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.loading = true;
      this.$http({
        url: '/api/okbAct/actOkSignLog/queryWithdrawLog',
        type: 'GET',
        hideAlert: true,
        data: {}
      }).then(res => {
        if (res.httpCode != 1) {
          this.loading = false;
          this.$notice.msg(res.msg);
          return;
        }
        this.money = res.data.amount;
        this.userName = res.data.userName;
        this.userNameKms = res.data.userNameKms;
        this.idNo = res.data.idNo;
        this.idNoKms = res.data.idNoKms;
        this.cardNo = res.data.cardNo;
        this.cardNoKms = res.data.cardNoKms;
        this.mobile = res.data.mobile;
        this.mobileKms = res.data.mobileKms;
        this.bank = res.data.bank;
        this.$set(this, 'bankText', res.data.bankText);
        this.disabledName = this.userType == 2 && res.data.userName ? true : false;
        this.disabledIdNo = this.userType == 2 && res.data.idNo ? true : false;
        this.showpPopup = true;
        this.loading = false;
      });
    },

    // 清空加密
    changeInputVal(keyKms) {
      this[keyKms] = '';
    },

    changeBankVal(e) {
      let value = e.target.value;
      this.changeInputVal('cardNoKms');
      if (!value) return;
      this.$http({
        url: '/api/tools/queryBankByCardNo?cardNo=' + value.replace(/\s*/g, ''),
        type: 'GET',
        data: {}
      }).then(res => {
        this.$emit('setBankTextValue', res.data);
      });
    },

    // 获取验证码
    checkCode() {
      if (this.codeIndex != this.CODE_SIZE) {
        return;
      }
      this.timerStart();
      this.$http({
        url: '/api/okbAct/actOkSignLog/sendCode',
        type: 'POST',
        data: {
          mobile: this.mobile.replace(/\s*/g, ''),
          mobileKms: this.mobileKms
        }
      })
        .then(res => {})
        .catch(e => {
          window.clearInterval(this.timer);
          this.codeIndex = CODE_SIZE;
        });
    },

    submit() {
      if (!this.userName) {
        this.$notice.msg('请输入姓名');
        return;
      }
      if (!this.idNo) {
        this.$notice.msg('请输入身份证号');
        return;
      }
      if (!this.cardNo) {
        this.$notice.msg('请输入银行账号');
        return;
      }
      if (!this.bank) {
        this.$notice.msg('请选择开户行');
        return;
      }
      if (!this.smsCode) {
        this.$notice.msg('请输入验证码');
        return;
      }
      this.$http({
        url: '/api/okbAct/actOkSignLog/startWithdraw',
        type: 'POST',
        data: {
          userName: this.userName.replace(/\s*/g, ''),
          userNameKms: this.userNameKms,
          idNo: this.idNo.replace(/\s*/g, ''),
          idNoKms: this.idNoKms,
          cardNo: this.cardNo.replace(/\s*/g, ''),
          cardNoKms: this.cardNoKms,
          bank: this.bank.replace(/\s*/g, ''),
          mobile: this.mobile.replace(/\s*/g, ''),
          mobileKms: this.mobileKms,
          smsCode: this.smsCode
        }
      }).then(res => {
        if (res.data.needFaceId == '0') {
          // 无需人脸
          this.clickWithdrawal();
        }
      });
    },

    // 确认提现
    clickWithdrawal() {
      this.loading = true;
      this.$http({
        url: '/api/okbAct/actOkSignLog/confirmWithdraw',
        type: 'GET',
        data: {}
      })
        .then(res => {
          this.loading = false;
          this.showpPopup = false;
          this.$emit('showWithdrawalSuccess');
        })
        .catch(() => {
          this.loading = false;
          this.showpPopup = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
}
.receive-success {
  position: relative;
  .money {
    position: absolute;
    top: 160px;
    left: 50%;
    margin-left: -150px;
    width: 300px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 0.5px;
  }
  img {
    width: 750px;
    height: 1102px;
  }
  .form-container {
    width: 475px;
    height: 480px;
    left: 50%;
    margin-left: -237px;
    position: absolute;
    bottom: 275px;

    .label-input {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .label {
        font-size: 26px;
        color: #ff6819;
        font-weight: bold;
        width: 216px;
        height: 60px;
        display: flex;
        align-items: center;
        text-align: right;
        justify-content: end;
        padding-right: 20px;
        width: 130px;
        min-width: 130px;
      }
      .input {
        height: 60px;
        width: 345px;
        min-width: 345px;
        border: 1px solid #ff6819;
        background: transparent;
        border-radius: 8px;
        padding-left: 16px;
        color: #2a3243;
        font-size: 28px;
        display: flex;
        align-items: center;
      }
      .disabled {
        color: #999 !important;
        border: 1px solid #ff6819;
        -webkit-color: #999; /*为Chrome/Safari*/
        -moz-color: #999; /*为Firefox*/
        -ms-color: #999; /*为IE*/
        -o-color: #999; /*为Opera*/
      }
      .code-box {
        position: relative;
        display: flex;
        width: 345px;
        min-width: 345px;
        border: 1px solid #ff6819;
        background: transparent;
        border-radius: 8px;
        .code-input {
          height: 60px;
          width: 200px;
          background: none;
          padding-left: 16px;
          color: #2a3243;
          font-size: 28px;
        }
        .get-code {
          position: absolute;
          right: 10px;
          color: #ff6819;
          font-weight: bold;
          top: 50%;
          margin-top: -20px;
        }
      }
    }
  }
  .submit-btn {
    position: absolute;
    bottom: 175px;
    left: 50%;
    margin-left: -180px;
    width: 360px;
    height: 70px;
    background: url('~@/static/images/activityCenter/202405/01/15.png') no-repeat;
    background-size: 100% 100%;
  }
  .close {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -19px;
  }
}
/deep/.van-popup__close-icon--bottom-right {
  border: 1px solid #f5f6f9;
  border-radius: 50%;
}
/deep/.van-popup__close-icon--bottom-right {
  font-size: 50px;
  bottom: 0px;
  margin-right: 315px;
}
/deep/.van-popup__close-icon {
  color: #f5f6f9;
}
</style>
